export default class ActiveToggle {
    constructor() {
        this._items = Array.from(document.querySelectorAll('.active-toggle'));
    }
    render() {
        if (this._items.length) {
            this._items.forEach((item) => {
                item.addEventListener('click', (e) => {
                    e.preventDefault();
                    if (!e.currentTarget.classList.contains('active')) {
                        e.currentTarget.classList.add('active');
                    } else {
                        e.currentTarget.classList.remove('active');
                    }
                });
            });
        }
    }
}
